import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useNotification } from './NotifPopup';

//DAFTAR CABANG
export function PageKonten8({token}) {
  const [data, setData] = useState([]);
  const [opsiWil, setOpsiWil] = useState({
    id:'', 
    nama:''});
  const dataKosong = {
    id:'',
    nama:'',
    idWil: '',
    alamat: '',
    telepon: ''
  };
  const [dataNew, setDataNew] = useState(dataKosong);
  const [kodeNew, setKodeNew] = useState('');
  const [sortBy, setSortBy] = useState('nama'); // 'kode' | 'nama'
  const [sortDir, setSortDir] = useState('asc'); // asc | desc
  const [showTambah, setShowTambah] = useState(false); // asc | desc
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState(dataKosong);
  const [showHapus, setShowHapus] = useState(false);
  const [hapusData, setHapusData] = useState(dataKosong);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const { showNotif } = useNotification();
  const bisaSubmit = dataNew.nama.trim() !== '' && dataNew.idWil.trim() !== '';

  //PAGINATION
  const loadData = async () => {
    await api.get(
      `${backendPort}/api/master/daftar_wilayah_opsi`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(res => {
        setOpsiWil(res.data);
      });
    
    await api.get(
      `${backendPort}/api/master/daftar_cabang`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  .then(res => {
    const lastId = res.data.length > 0 ? res.data[res.data.length - 1].kode_cabang : '';
    const nomor = Number(lastId.split('-')[1]) + 1;
    console.log(`kodeNew: C-${nomor}`);
    setKodeNew(`C-${nomor}`);
    setData(res.data);}
  )
  .catch(err => console.error(err));
  };

  useEffect(() => {
    loadData();
  }, []);

  const filteredData = useMemo(() => {
      return data.filter(item => {
        const searchMatch =
          item.nama_cabang.toLowerCase().includes(search?.toLowerCase()?? '');
        return searchMatch;
      });
    }, [data, search]);

  const PAGE_SIZE_OPTIONS = [5, 10, 20];
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const paginatedData = filteredData.slice(
    (page - 1) * pageSize,
    page * pageSize
  );
  const maxVisible = 5;
  let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
  let endPage = startPage + maxVisible - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisible + 1);
    }
  const visiblePages = [];  
  for (let i = startPage; i <= endPage; i++) {
  visiblePages.push(i);}

  const handleTambah = async (e) => {
    try{
      e.preventDefault();
      setShowTambah(false);
      console.log('kirim ke API= ',dataNew);  
      await api.post(`${backendPort}/api/master/tambah_cabang`, {
        kode: kodeNew, 
        nama: dataNew.nama, 
        idWil: Number(dataNew.idWil), 
        alamat: dataNew.alamat, 
        telepon: dataNew.telepon
      });
      showNotif('success', 'Data Berhasil Ditambahkan');
      setDataNew(dataKosong);
      loadData();
    } catch (err) {
      showNotif('error', 'Penambahan Data Gagal');
    }
  };
  
  const handleEdit = async (e) => {
    try{
      console.log('editData =', editData);  
      e.preventDefault();
      setShowEdit(false);
      await api.put(
      `${backendPort}/api/master/edit_cabang/${editData.kode}`,
      { nama: editData.nama,
        idWil: Number(editData.idWil), 
        alamat: editData.alamat, 
        telepon: editData.telepon
       });
      
      showNotif('success', 'Update Data Berhasil');
      loadData();
    }
    catch(e)
    {showNotif('error', 'Update Data Gagal');}
  };
  
  const handleDelete = async (e) => {
    try{
      if (e) e.preventDefault();
      setShowHapus(false);
      await api.delete(
      `${backendPort}/api/master/delete_cabang/${hapusData.kode}`
      );
      
      showNotif('success', 'Delete Data Berhasil');
      loadData();
    }
    catch(e)
    {showNotif('error', 'Delete Data Gagal');}
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortDir(sortDir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortDir('asc');
    }
  };

const sortedData = [...paginatedData].sort((a, b) => {
  if (!sortBy) return 0;

  const getValA = () => {
    switch (sortBy) {
      case 'kolom1': return a.id;
      case 'kolom2': return a.nama_cabang;
      case 'kolom3': return a.nama_wilayah;
      default: return a.id;
    }
  };

  const getValB = () => {
    switch (sortBy) {
      case 'kolom1': return b.id;
      case 'kolom2': return b.nama_cabang;
      case 'kolom3': return b.nama_wilayah;
      default: return b.id;
    }
  };

  const valA = getValA();
  const valB = getValB();

  // number
  if (typeof valA === 'number' && typeof valB === 'number') {
    return sortDir === 'asc' ? valA - valB : valB - valA;
  }

  // string
  return sortDir === 'asc'
    ? String(valA).localeCompare(String(valB))
    : String(valB).localeCompare(String(valA));
});

  return (
    <div className="container-fluid">
      <div className="row">
                {/* TABLE */}
        <div className="col-md-8">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center" style={{ background: "#09314F", color: "#fff" }}>
            Daftar Cabang
            <button className="btn btn-outline-secondary ls" style={{fontSize: "large", color: "#fff"}} 
              onClick={()=>{
                setShowTambah(!showTambah); 
                setShowEdit(false); 
                setShowHapus(false); 
                }}>Tambah <i className="fa fa-add"></i></button>
            </div>

            <div className="card-body p-0">
              <div className="row my-2 mx-1">
                  <div className="col-md-4">
                    <input
                      className="form-control"
                      placeholder="Cari Cabang.."
                      value={search}
                      onChange={e => {
                        setSearch(e.target.value);
                        setPage(1);
                      }}
                    />
                  </div>
                <div className="col-md-4"></div>
                <div className="col-md-4 text-end">
                  <label className="form-label">Show</label>
                  <select
                    className="form-select w-auto d-inline-block ms-2"
                    value={pageSize}
                    onChange={e => {
                      setPageSize(Number(e.target.value));
                      setPage(1);
                    }}
                  >
                    {PAGE_SIZE_OPTIONS.map(x => (
                      <option key={x}>{x}</option>
                    ))}
                  </select>
                </div>
              </div>
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th onClick={() => handleSort('kolom1')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Kode</span>
                        {sortBy === 'kolom1' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>

                    <th onClick={() => handleSort('kolom2')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Cabang</span>
                        {sortBy === 'kolom2' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>

                    <th onClick={() => handleSort('kolom3')} style={{ cursor: 'pointer' }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Wilayah</span>
                        {sortBy === 'kolom3' && (
                          <span>{sortDir === 'asc' ? '▲' : '▼'}</span>
                        )}
                      </div>
                    </th>

                    <th>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Alamat</span>
                      </div>
                    </th>

                    <th>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>No Telp.</span>
                      </div>
                    </th>

                    <th width="80">Aksi</th>
                 
                  </tr>
                </thead>
                <tbody>
                    {sortedData.map((row) => (
                      <tr key={row.kode_cabang}>
                        <td className='single-line'>{row.kode_cabang}</td>
                        <td className='single-line'>{row.nama_cabang}</td>
                        <td className='single-line'>{row.nama_wilayah}</td>
                        <td className='single-line'>{row.alamat}</td>
                        <td className='single-line'>{row.telepon}</td>    
                        <td className="d-flex justify-content-between align-items-center">
                          <span onClick={() => {
                              setEditData({
                                kode: row.kode_cabang, 
                                nama: row.nama_cabang,
                                idWil: row.kode_wilayah,
                                namaWil: row.nama_wilayah,
                                alamat: row.alamat,
                                telepon: row.telepon
                            });
                              setShowEdit(!showEdit);
                              setShowTambah(false);
                              setShowHapus(false);
                            }}
                            style={{ cursor: 'pointer' }}>
                            <i className="fa fa-folder-open"></i>
                            </span>

                          <span onClick={() => {
                              setHapusData({
                                kode: row.kode_cabang, 
                                nama: row.nama_cabang,
                                idWil: row.kode_wilayah,
                                alamat: row.alamat,
                                telepon: row.telepon
                                });
                              setShowHapus(!showHapus);
                              setShowTambah(false);
                              setShowEdit(false);
                            }}
                            style={{ cursor: 'pointer' }}>
                              <i className="fa fa-trash text-red-500"></i>
                              </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {/* PAGINATION NAV */}
            <div className="d-flex justify-content-between align-items-center my-2 mx-3">
            <div>
              Showing {(page - 1) * pageSize + 1} to{" "}
              {Math.min(page * pageSize, filteredData.length)} of{" "}
              {filteredData.length} entries
            </div>

            <nav>
              <ul className="pagination mb-0">
                <li className={`page-item ${page === 1 && "disabled"}`}>
                  <button
                    className="page-link"
                    onClick={() => setPage(1)}
                  >
                    ←
                  </button>
                </li>

                {visiblePages.map(p => (
                  <li
                    key={p}
                    className={`page-item ${page === p && "active"}`}
                  >
                    <button className="page-link" onClick={() => setPage(p)}>
                      {p}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${
                    page === totalPages && "disabled"
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(totalPages)}
                  >
                    →
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          </div>
        </div>


        {/* FORM TAMBAH*/}
        {showTambah && <div className="col-md-4">
          <div className="card">
            <div className="card-header" style={{ background: "#09314F", color: "#fff"}}>
              Tambah Cabang Baru
            </div>
            <div className="card-body">
              <form onSubmit={handleTambah}>
                <div className="mb-3">
                  <label>Kode</label>
                  <input
                    className="form-control"
                    value={kodeNew}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama</label>
                  <input
                    className="form-control"
                    value={dataNew.nama}
                    onChange={(e) => setDataNew(prev=>({...prev, nama: e.target.value}))}
                  />
                </div>
                <div className="mb-3">
                  <label>Wilayah</label>
                  <select
                    className="form-select"
                    value={dataNew.idWil}
                    onChange={e => setDataNew(prev=>({...prev, idWil: e.target.value}))}
                  >
                    <option value = ''>--pilih Wilayah--</option>
                    { 
                      opsiWil.map(x => (
                      <option value={x.id}>{x.nama_wilayah}</option>
                    ))
                    }
                  </select>  
                </div>
                <div className="mb-3">
                  <label>Alamat</label>
                  <input
                    className="form-control"
                    value={dataNew.alamat}
                    onChange={(e) => setDataNew(prev=>({...prev, alamat: e.target.value}))}
                  />
                </div>
                <div className="mb-3">
                  <label>No. Telp</label>
                  <input
                    className="form-control"
                    value={dataNew.telepon}
                    onChange={(e) => setDataNew(prev=>({...prev, telepon: e.target.value}))}
                  />
                </div>
                
                <button className="btn btn-primary me-2"
                    disabled = {!bisaSubmit} 
                  >Simpan</button>
                
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setDataNew(dataKosong);
                    setShowTambah(false);
                  }}
                >
                  Batal
                </button>
              </form>
            </div>
          </div>
        </div>}

        {/* FORM Edit*/}
        {showEdit && <div className="col-md-4">
          <div className="card">
            <div className="card-header" style={{background: "#09314F", color: "#fff" }}>
              Edit Data Cabang
            </div>
            <div className="card-body">
              <form onSubmit={handleEdit}>
                <div className="mb-3">
                  <label>Kode</label>
                  <input
                    className="form-control"
                    value={editData.kode}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama</label>
                  <input
                    className="form-control"
                    value={editData.nama}
                    onChange={(e) => setEditData(prev => ({ ...prev, nama: e.target.value }))}
                  />
                </div>

                <div className="mb-3">
                <label>Wilayah</label>
                  <select
                    className="form-select"
                    value={editData.idWil}
                    onChange={e => {setEditData(prev => ({ ...prev, idWil: e.target.value }))}}
                  >
                    {
                      opsiWil.map(x => (
                      <option value={x.id}>{x.nama_wilayah}</option>
                    ))
                    }
                  </select>  
                </div>

                <div className="mb-3">
                  <label>Alamat</label>
                  <input
                    className="form-control"
                    value={editData.alamat}
                    onChange={(e) => setEditData(prev => ({ ...prev, alamat: e.target.value }))}
                  />
                </div>

                <div className="mb-3">
                  <label>No. Telp</label>
                  <input
                    className="form-control"
                    value={editData.telepon}
                    onChange={(e) => setEditData(prev => ({ ...prev, telepon: e.target.value }))}
                  />
                </div>

                <button className="btn btn-primary me-2"
                    >Update</button>
  
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setEditData([]);
                    setShowEdit(false);
                  }}
                > Batal</button>
              </form>
            </div>
          </div>
        </div>}

        {/* FORM Hapus*/}
        {showHapus && <div className="col-md-4">
          <div className="card">
            <div className="card-header" style={{ background: "#dc3545", color: "#fff" }}>
              Hapus Cabang
            </div>
            <div className="card-body">
              <form onSubmit={handleDelete}>
                <div className="mb-3">
                  <label>Kode</label>
                  <input
                    className="form-control"
                    value={hapusData.kode}
                    disabled
                  />
                </div>
                
                <div className="mb-3">
                  <label>Nama</label>
                  <input
                    className="form-control"
                    value={hapusData.nama}
                    disabled
                  />
                </div>

                <button className="btn btn-danger me-2" 
                    //disabled
                    >Delete</button>
  
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    setHapusData('');
                    setShowHapus(false);
                  }}
                > Batal</button>
              </form>
            </div>
          </div>
        </div>}

      </div>
    </div>
  );
}
